import { useNavigate } from '@solidjs/router';
import { BrowserId } from 'Browser/BrowserId';
import { sameId } from 'Browser/BrowserId';
import { User } from 'Browser/User';
import { VenueRole } from 'Common/permissions/VenueRole';
import { SiteBasics } from 'Common/SiteBasics';
import { useSite, useUser } from 'Shared/SiteProvider';
import { Match, onMount, Show, Switch } from 'solid-js';


export function Page(P:{requiresLogin:boolean})
{
	onMount(() => document.body.style.opacity = '1');

	const site = useSite();
	const user = useUser();

//TODO provide decent Missing permissions and Page not found errors... 

//XXX if using ErrorBoundary probably should send errors to server
//XXX perhaps also send browser-side 'page not founds' to server

//XXX ErrorBoundary sometimes hides errors... Also could put in Root.tsx
//		<ErrorBoundary fallback={err => <pre>{JSON.stringify(err)}</pre>}>

	if (P.requiresLogin && user.isUnknown())
		useNavigate()('/login');

	const havePermission = () => site.type!='venue' || haveVenueRole(user,site);

	return (
		<Switch>
			<Match when={!P.requiresLogin}>
				{P.children}
			</Match>
			<Match when={!user.isUnknown()}>
				<Show when={havePermission()} fallback='You lack permissions for this site'>
					{P.children}
				</Show>
			</Match>
		</Switch>
	);

//		</ErrorBoundary>
}

//TODO possibly move to Roles or VenueRoles
export function haveVenueRole(user:User,site:SiteBasics<BrowserId>)
{
	for (const role of user.roles) {
		if (role instanceof VenueRole && sameId(role.config?.siteId,site.id)) 
			return true;
		if (role.name == 'admin')
			return true;
	}

	return false;
}

